<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="9" fill="#709F34"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.4867 9.83097C5.2721 9.9741 5.22612 10.2763 5.36407 10.4989C5.50203 10.7216 5.79326 10.7693 6.00786 10.6261C6.03852 10.6102 6.06917 10.5784 6.0845 10.5625L8.98154 7.97025L11.9246 10.5625C12.0932 10.7534 12.3844 10.7693 12.5684 10.5784C12.7523 10.4035 12.7676 10.1013 12.5837 9.91049C12.553 9.87868 12.5377 9.86278 12.507 9.84687L8.96621 6.71387L5.4867 9.83097Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'up-arrow-icon'
}
</script>
